module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/people_c2-71c065e22f2684feb71a7e86beea82fb.svg";